import { makeIconOnlyButton } from './the-every-button';

// These buttons are only ever used inside the component library, so we do not
// export them with the rest

export const MinusButton = makeIconOnlyButton({ icon: 'remove', size: 'small' });
export const PlusButton = makeIconOnlyButton({ icon: 'add', size: 'small' });
